import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../../lib/client';
import toast from 'react-hot-toast';

interface DeleteExpenseResponse {
  success: boolean;
  message: string;
}

const deleteExpense = async (expenseId: string): Promise<DeleteExpenseResponse> => {
  const response = await client.delete(`/expenses/${expenseId}/delete`);
  return response.data;
};

export const useDeleteExpense = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['groupExpenses'] });
      queryClient.invalidateQueries({ queryKey: ['allExpenseParticipations'] });
      
      toast.success('지출이 삭제되었습니다!', {
        icon: '🗑️',
      });
    },
    onError: (error: any) => {
      console.error('지출 삭제 실패:', error);
      toast.error(error.response?.data?.error || '지출 삭제에 실패했습니다.', {
        icon: '❌',
      });
    },
  });
}; 